import { render, staticRenderFns } from "./system-500.vue?vue&type=template&id=4bb7ce1e&"
import script from "./system-500.vue?vue&type=script&lang=js&"
export * from "./system-500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports